module.exports = __webpack_public_path__ + "static/media/nonprofit3.c6adfb86.png";